export const SEARCH_WORD = 'SEARCH_WORD';
